module.exports = __webpack_public_path__ + "img/user_icon.3394430c.png";